import { Menu, X } from 'lucide-react'
import { useState } from 'react'
import { Link, NavLink, Outlet } from 'react-router-dom'
import { BrandMark } from './BrandMark'

const links = [
  ['/platform', 'How it works'],
  ['/solutions', 'What it can help with'],
  ['/pricing', 'Costs'],
  ['/security', 'Safety'],
]

export function PublicLayout() {
  const [menuOpen, setMenuOpen] = useState(false)
  return (
    <div className="public-shell">
      <header className="site-header">
        <div className="container site-header__inner">
          <Link to="/" className="brand-link" onClick={() => setMenuOpen(false)}><BrandMark /></Link>
          <nav className={`site-nav ${menuOpen ? 'site-nav--open' : ''}`} aria-label="Primary navigation">
            {links.map(([to, label]) => <NavLink key={to} to={to} onClick={() => setMenuOpen(false)}>{label}</NavLink>)}
            <NavLink to="/login" onClick={() => setMenuOpen(false)}>Client sign in</NavLink>
            <Link className="button button--gold button--small" to="/request-demo" onClick={() => setMenuOpen(false)}>See what DAWN could save</Link>
          </nav>
          <button className="mobile-menu-button" onClick={() => setMenuOpen(value => !value)} aria-label="Toggle navigation">
            {menuOpen ? <X /> : <Menu />}
          </button>
        </div>
      </header>
      <main><Outlet /></main>
      <footer className="site-footer">
        <div className="container site-footer__grid">
          <div>
            <BrandMark light />
            <p>DAWN helps growing businesses organise repeat work, prepare drafts, track what is happening and bring important decisions back to a person. Start with one time-consuming job and expand only when the saving is proven.</p>
            <span className="footer-endorsement">A Deus Intus system</span>
          </div>
          <div>
            <strong>Understand DAWN</strong>
            <Link to="/platform">How it works</Link>
            <Link to="/solutions">What it can help with</Link>
            <Link to="/pricing">Costs</Link>
          </div>
          <div>
            <strong>Stay in control</strong>
            <Link to="/security">Safety and approvals</Link>
            <Link to="/privacy">Privacy readiness</Link>
            <Link to="/terms">Terms readiness</Link>
          </div>
          <div>
            <strong>Next step</strong>
            <Link to="/login">Client sign in</Link>
            <Link to="/request-demo">See what DAWN could save</Link>
          </div>
        </div>
        <div className="container site-footer__base">
          <span>© 2026 DAWN OS. Founding customer programme.</span>
          <span>Awaken the Power Within.</span>
        </div>
      </footer>
    </div>
  )
}
